import cx from 'clsx';
import type { ReactNode } from 'react';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import { TermsAndConditionsPlaceholder } from '../../placeholders';
import styles from './terms-and-conditions-link.module.css';

export function TermsAndConditionsLink(): ReactNode {
  const { settings } = usePdfPreviewContext();

  return (
    <TermsAndConditionsPlaceholder>
      {settings?.tcLinkText ? (
        <a
          className={cx(styles.termsAndConditionsLink, 'body-1')}
          data-testid="pdf-preview-tc-link"
          href={settings.tcLinkUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {settings.tcLinkText}
        </a>
      ) : null}
    </TermsAndConditionsPlaceholder>
  );
}
